{
  "metadata": {
    "id": "synthwave84-dark",
    "name": "Synthwave '84",
    "description": "Портировано из темы «Synthwave '84» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "synthwave84.json",
      "project": "robb0wen",
      "url": "https://github.com/robb0wen/synthwave-vscode",
      "upstreamFile": "packages/ui/src/theme/themes/synthwave84.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.3,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.465,
      "paletteMaxS": 0.517,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.1,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 31.5,
      "syntaxVsTextMinDeltaE": 41.2,
      "chartsMinDeltaE": 29.0,
      "textSeparationDeltaE": 36.2,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "keyword",
          "b": "operator",
          "deltaE": 0.0
        },
        {
          "a": "number",
          "b": "function",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#36f9f6",
      "hover": "#4efaf7",
      "active": "#5efaf8",
      "foreground": "#000000",
      "muted": "#36f9f680",
      "emphasis": "#36f9f6"
    },
    "surface": {
      "background": "#262335",
      "foreground": "#ffffff",
      "muted": "#373546",
      "mutedForeground": "#a4a9ce",
      "elevated": "#403e4e",
      "elevatedForeground": "#ffffff",
      "raised": "#575564",
      "raisedForeground": "#ffffff",
      "overlay": "#262335cc",
      "subtle": "#2e2c3d"
    },
    "interactive": {
      "border": "#5a5867",
      "borderHover": "#63616e",
      "borderFocus": "#36f9f6",
      "selection": "#ffffff29",
      "selectionForeground": "#ffffff",
      "focus": "#36f9f659",
      "focusRing": "#36f9f661",
      "cursor": "#ffffff",
      "hover": "#ffffff1c",
      "active": "#ffffff29"
    },
    "status": {
      "error": "#fe4955",
      "errorForeground": "#000000",
      "errorBackground": "#fe495524",
      "errorBorder": "#fe495573",
      "warning": "#fede5d",
      "warningForeground": "#000000",
      "warningBackground": "#fede5d24",
      "warningBorder": "#fede5d73",
      "success": "#72f1b8",
      "successForeground": "#000000",
      "successBackground": "#72f1b824",
      "successBorder": "#72f1b873",
      "info": "#ff8b39",
      "infoForeground": "#000000",
      "infoBackground": "#ff8b3924",
      "infoBorder": "#ff8b3973"
    },
    "pr": {
      "open": "#72f1b8",
      "draft": "#b2b7d6",
      "blocked": "#fede5d",
      "merged": "#b084eb",
      "closed": "#fe4955"
    },
    "syntax": {
      "base": {
        "background": "#4a4858",
        "foreground": "#ffffff",
        "comment": "#b2b7d6",
        "keyword": "#ff98e2",
        "string": "#fede5d",
        "number": "#ccb0f2",
        "function": "#ccb0f2",
        "variable": "#ffffff",
        "type": "#36f9f6",
        "operator": "#ff98e2"
      },
      "tokens": {
        "commentDoc": "#b2b7d6",
        "stringEscape": "#ff98e2",
        "keywordImport": "#ff98e2",
        "storageModifier": "#ff98e2",
        "functionCall": "#ccb0f2",
        "method": "#ccb0f2",
        "variableProperty": "#ccb0f2",
        "variableOther": "#ffffff",
        "variableGlobal": "#ccb0f2",
        "variableLocal": "#ff98e2",
        "parameter": "#ffffff",
        "constant": "#ccb0f2",
        "class": "#36f9f6",
        "className": "#36f9f6",
        "interface": "#36f9f6",
        "struct": "#36f9f6",
        "enum": "#36f9f6",
        "typeParameter": "#36f9f6",
        "namespace": "#36f9f6",
        "module": "#ff98e2",
        "tag": "#ff98e2",
        "jsxTag": "#ff98e2",
        "tagAttribute": "#ccb0f2",
        "tagAttributeValue": "#fede5d",
        "boolean": "#ccb0f2",
        "decorator": "#ff98e2",
        "label": "#ccb0f2",
        "regexp": "#fede5d"
      }
    },
    "charts": {
      "series": [
        "#36f9f6",
        "#ff8b39",
        "#72f1b8",
        "#fede5d",
        "#fe4955"
      ]
    },
    "chat": {
      "background": "#262335",
      "userMessage": "#ffffff",
      "userMessageBackground": "#403e4e",
      "assistantMessage": "#ffffff",
      "assistantMessageBackground": "#373546",
      "timestamp": "#b2b7d6",
      "divider": "#5a5867",
      "typing": "#b2b7d6"
    },
    "loading": {
      "spinner": "#36f9f6",
      "spinnerTrack": "#373546",
      "skeleton": "#373546",
      "shimmer": "#555362"
    },
    "tools": {
      "background": "#373546",
      "border": "#5a5867",
      "headerHover": "#535160",
      "icon": "#36f9f6",
      "title": "#ffffff",
      "description": "#b2b7d6",
      "edit": {
        "added": "#72f1b8",
        "addedBackground": "#72f1b824",
        "removed": "#fe4955",
        "removedBackground": "#fe495524",
        "modified": "#ff8b39",
        "modifiedBackground": "#ff8b3924",
        "lineNumber": "#b2b7d6"
      }
    },
    "markdown": {
      "heading1": "#ffffff",
      "heading2": "#ffffff",
      "heading3": "#ffffff",
      "heading4": "#ffffff",
      "link": "#36f9f6",
      "linkHover": "#4efaf7",
      "inlineCode": "#fede5d",
      "inlineCodeBackground": "#373546",
      "blockquote": "#b2b7d6",
      "blockquoteBorder": "#5a5867",
      "listMarker": "#36f9f6bf",
      "bold": "#ffffff",
      "italic": "#ffffffe6",
      "strikethrough": "#b2b7d6",
      "hr": "#5a5867"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#be4541",
        "foreground": "#ffffff",
        "contrast": 5.1
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#bc7d59",
        "foreground": "#000000",
        "contrast": 6.22
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#e1c8a5",
        "foreground": "#000000",
        "contrast": 13.01
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#c1bc63",
        "foreground": "#000000",
        "contrast": 10.64
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#8ac652",
        "foreground": "#000000",
        "contrast": 10.28
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#b4e3a7",
        "foreground": "#000000",
        "contrast": 14.49
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#54c57b",
        "foreground": "#000000",
        "contrast": 9.65
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#59bb9e",
        "foreground": "#000000",
        "contrast": 9.03
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#abd7dd",
        "foreground": "#000000",
        "contrast": 13.5
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4c9fc1",
        "foreground": "#000000",
        "contrast": 7.04
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#3c5aba",
        "foreground": "#ffffff",
        "contrast": 6.24
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#a5a5d8",
        "foreground": "#000000",
        "contrast": 8.97
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#8944bb",
        "foreground": "#ffffff",
        "contrast": 5.82
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#be81ca",
        "foreground": "#000000",
        "contrast": 7.18
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#c048a9",
        "foreground": "#000000",
        "contrast": 4.74
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#dfa2b4",
        "foreground": "#000000",
        "contrast": 9.96
      }
    ]
  }
}
